class StickyHeader extends HTMLElement {
    constructor() {
        super()
        this.transparentHeader = this.classList.contains('transparent-header')
    }

    connectedCallback() {
        [...this.querySelectorAll('.mm-close')].forEach((element) => {
            element.addEventListener('click', () => {
                this.closeMenu()
            })
        })

        this.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => {
                this.closeMenu()
            })
        })

        if (this.transparentHeader) {
            //if the header is transparent, then add the blurred class when the user scrolls down
            window.addEventListener('scroll', () => {
                if (document.documentElement.scrollTop >= 330) {
                    this.classList.add('blurred')
                } else {
                    this.classList.remove('blurred')
                }
            })
        }

        this.addEventListener('mouseleave', () => {
            this.classList.remove('active')
        })

        this.addEventListener('mouseover', () => {
            this.classList.add('active')
        })
    }

    closeMenu() {
        document.body.classList.remove('overflow-hidden')
        const menu = this.querySelector('mobile-menu')
        menu.classList.remove('mm-open')
        this.classList.remove('active')
    }
}

customElements.define('sticky-header', StickyHeader)
